import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_3: FaireProductEntity = {
  token: "atc_updated_moma_3",
  type: "product",
  name: "Anthora Greek Coffee Cups Set",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/553d4dc7524af372ed1f4074d25c5f202a7088ee4bf8967d4b01716a893eb119.webp",
  priceDollars: 32,
  msrpDollars: 38,
  description: "We Are Happy To Serve You.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
